import React, { useEffect, useState } from "react";
import { Typography, TextField, Grid, Link, Box } from "@mui/material";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { companySettingsApi } from "../../../Data/axios";
function GoogleSettingsTab() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const [appDetails, setAppDetails] = useState({
    site_google_map: "",
    google_calender_id: "",
    google_calender_key: "",
  });

  const handleChange = (e) =>
    setAppDetails({ ...appDetails, [e.target.name]: e.target.value });

  useEffect(() => {
    getCompanyData();
  }, []);

  const getCompanyData = async () => {
    try {
      let response = await companySettingsApi.getAll();
      console.log(response[0], "response not got");

      const data = response[0];

      setAppDetails({
        site_google_map: data.site_google_map || "",
        google_calender_id: data.google_calender_id || "",
        google_calender_key: data.google_calender_key || "",
      });
    } catch (error) {
      console.error("Failed to fetch company data", error);
    }
  };

  const updateCalenderData = async (e) => {
    try {
      await companySettingsApi.googleSettingsUpdate(appDetails);
      showAlert("Updated successfully!!", "success");
    } catch (error) {
      showAlert("Failed to update!", "error");
    }
  };

  return (
    <Box
      sx={{
        overflowY: "auto", // Enable vertical scrolling
      }}
    >
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      <Box
        component="form"
        sx={{
          p: 2,
          borderRadius: 1,
          mb: 3,
        }}
      >
        <Typography variant="h5" gutterBottom style={{ color: "black" }}>
          Google map api
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              placeholder="Map api"
              name="site_google_map"
              onChange={handleChange}
              value={appDetails.site_google_map}
              sx={{
                backgroundColor: "white",
                "& .MuiInputBase-input": {
                  color: "black",
                },
              }}
              InputLabelProps={{
                style: { color: "black" },
              }}
              InputProps={{
                style: {
                  color: "black",
                  border: "1px solid black",
                  borderRadius: "4px",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" style={{ color: "black" }}>
              Visit{" "}
              <Link
                href="https://console.cloud.google.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Cloud Console
              </Link>{" "}
              to get the keys
            </Typography>
          </Grid>
        </Grid>
        <Typography
          variant="h5"
          gutterBottom
          style={{ color: "black", marginTop: "20px" }}
        >
          Google Calander api
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              name="google_calender_id"
              placeholder="Google Calender ID"
              onChange={handleChange}
              value={appDetails.google_calender_id}
              sx={{
                backgroundColor: "white",
                "& .MuiInputBase-input": {
                  color: "black",
                },
              }}
              InputLabelProps={{
                style: { color: "black" },
              }}
              InputProps={{
                style: {
                  color: "black",
                  border: "1px solid black",
                  borderRadius: "4px",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              name="google_calender_key"
              placeholder="Google Calender Key"
              onChange={handleChange}
              value={appDetails.google_calender_key}
              sx={{
                backgroundColor: "white",
                "& .MuiInputBase-input": {
                  color: "black",
                },
              }}
              InputLabelProps={{
                style: { color: "black" },
              }}
              InputProps={{
                style: {
                  color: "black",
                  border: "1px solid black",
                  borderRadius: "4px",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                padding: "10px",

                height: "40px",
                width: "150px",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                borderRadius: "4px",
                fontSize: "15px",
                fontFamily: "sans-serif",
                cursor: "pointer",
              }}
              onClick={updateCalenderData}
            >
              Save Calander Api
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default GoogleSettingsTab;
